module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA9ElEQVRYR8XXsQnCQBTG8XcRHECwtLTRJbxGnSBbpHADN5DgFtqLhSBc4RSWLmFxUQ4UJGBy9973kizw/+Wu+DhDSl/hLrPM+21pV3lTwmj0P/EDEc0zek13dn3/14EDfuNkTF4ulsfOTiA1HmCwE+DEYQBuHAKQxMUAaVwEQMTZAFScBUDGkwHoeBJAIx4N0IpHATTjrYDCncaZH1zDqsUMC2dZG7dgczuPqqdxvQHCH/V6Bd8j1UREz7EWIhqgdR1JAA1EMgCNYAGQCDYAhRABEAgxQIqAACQIGICLgAI4CDigjqhoONlb++jscVobsNbn+RsAq98hZDpuGgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/live/back_icon.png
// module id = N2p2
// module chunks = 1